/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import styles from './styles/volume-slider.css';

export const VolumeSlider = ({volume, muted, changeVolume}) => (
  <div className={styles.volumeSliderContainer}>
    <input
      className={styles.volumeSlider}
      onChange={(event) => {
        event.preventDefault();
        changeVolume(parseInt(event.target.value) / 100);
      }}
      type="range"
      step="1"
      max="100"
      value={muted ? 0 : volume * 100}
    />
    <progress
      className={styles.volumeProgress}
      max="100"
      value={muted ? 0 : volume * 100}
    />
  </div>
);

VolumeSlider.propTypes = {
  muted: PropTypes.bool.isRequired,
  volume: PropTypes.number.isRequired,
  changeVolume: PropTypes.func.isRequired
};

export default VolumeSlider;